var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "42px",
    viewBox: "0 0 32 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_business report_4072257") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Accueil---Recherche---autocompletion-fact",
    transform: "translate(-1338.000000, -881.000000)",
    fill: "#232323",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy",
    transform: "translate(1257.000000, 860.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_business-report_4072257",
    transform: "translate(81.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4700028,12 C9.63643904,12.316092 5,17.1055722 5,22.9835082 C5,29.0675912 9.95991153,34 16.079624,34 C17.4619851,34 18.7793752,33.7361319 20,33.2784858 L15.4713851,23.1126937 L15.4713851,12 L15.4700028,12 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6856622,13.0382353 L17,13 L17,23.1059838 L26.5615405,26 L26.7202706,25.3196755 C26.9089253,24.5206897 27,23.7586207 27,22.9952333 C26.9986989,17.7003043 22.9081447,13.3269777 17.6856622,13.0382353 Z M25.5883424,24.3308316 L18.2997658,22.1250507 L18.2997658,14.4199797 C22.5009107,14.9948276 25.6976321,18.6350913 25.6976321,22.9965517 C25.6976321,23.4369168 25.6625033,23.8786004 25.5883424,24.3308316 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8035873,33 C23.2063445,31.7128882 25.0754521,29.5048137 26,26.8159938 L17,24 L20.8035873,33 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6156898,0 L8.7440243,0 L0,9.74535484 L0,38.64 C0,40.4920645 1.5194534,42 3.38566437,42 L28.6143247,42 C30.4805356,42 32,40.4920645 32,38.64 L32,3.36 C32.0027194,1.50793548 30.4819008,0 28.6156898,0 Z M30.0109112,38.64 C30.0109112,39.4027742 29.3842903,40.0232903 28.617055,40.0232903 L3.38702955,40.0232903 C2.61706395,40.0232903 1.99317338,39.4014194 1.99317338,38.64 L1.99317338,10.5826452 L8.16791529,10.5826452 C9.48805135,10.5826452 10.556993,9.52180645 10.556993,8.21167742 L10.556993,1.97670968 L28.6156898,1.97670968 C29.3842903,1.97670968 30.009546,2.59858065 30.009546,3.36 L30.009546,38.64 L30.0109112,38.64 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObject);
export default __webpack_public_path__ + "static/media/object.1b76cb89fd7c20f2e2ba0cf96b10f93f.svg";
export { ForwardRef as ReactComponent };